<template>
    <div class="app-inner">
        <div>
            <h2 style="text-align: center;padding-top: 50px">账号管理</h2>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {}
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/config/account.vue